import React, { useState } from "react";
import "./Placements.css";
import { Helmet } from "react-helmet-async";

const Placements = () => {

    const [placementOpenFAQ, setPlacementOpenFAQ] = useState(null);

    const placementFAQs = [
        {
            question: "Does PRT Academy provide placement assistance in Hyderabad?",
            answer:
                "Yes. PRT Academy provides placement assistance to eligible students and helps them prepare for software job opportunities through career guidance, interview preparation, resume support, mock interviews, and job-search assistance."
        },
        {
            question: "What does placement assistance at PRT Academy include?",
            answer:
                "Placement assistance may include resume guidance, interview preparation, mock interviews, technical interview support, communication guidance, career counseling, and assistance in identifying relevant job opportunities."
        },
        {
            question: "Who is eligible for placement assistance at PRT Academy?",
            answer:
                "Eligibility depends on the course, program requirements, skills, attendance, performance, and other applicable criteria. Students should contact PRT Academy for the current eligibility requirements."
        },
        {
            question: "Does PRT Academy provide job placement for freshers?",
            answer:
                "PRT Academy supports eligible freshers by helping them develop job-ready technical and communication skills and prepare for interviews and relevant software job opportunities. Placement assistance does not necessarily mean a guaranteed job."
        },
        {
            question: "How does the PRT Academy placement process work?",
            answer:
                "The placement process generally involves preparing your resume, improving technical and communication skills, participating in mock interviews, preparing for company interviews, and receiving guidance when relevant job opportunities become available."
        },
        {
            question: "Does PRT Academy help with resume preparation?",
            answer:
                "Yes. Resume guidance is part of the career and placement support provided to help students present their technical skills, projects, internship experience, and qualifications effectively."
        },
        {
            question: "Does PRT Academy conduct mock interviews?",
            answer:
                "Yes. Mock interviews can help students practice technical and HR interview situations, improve communication, identify areas for improvement, and build confidence before attending actual interviews."
        },
        {
            question: "Does PRT Academy provide technical interview preparation?",
            answer:
                "Yes. Students can receive guidance for technical interviews based on their selected training program. Preparation may cover programming concepts, problem-solving, Data Structures & Algorithms, projects, technical fundamentals, and commonly asked interview topics."
        },
        {
            question: "Can students get placement assistance after completing their IT course?",
            answer:
                "Eligible students can receive placement assistance based on the applicable program terms and eligibility criteria. Students should confirm the current placement-support process with PRT Academy."
        },
        {
            question: "Does PRT Academy provide career guidance for IT jobs?",
            answer:
                "Yes. PRT Academy provides career guidance to help students understand relevant technology roles, improve their skills, prepare for interviews, and identify suitable career opportunities based on their interests and qualifications."
        },
        {
            question: "How can I get placement assistance from PRT Academy?",
            answer:
                "Students interested in placement assistance can contact PRT Academy through the website to learn about the applicable course requirements, eligibility criteria, placement-support process, and current opportunities."
        }
    ];

    const togglePlacementFAQ = (index) => {
        setPlacementOpenFAQ(
            placementOpenFAQ === index ? null : index
        );
    };

    return (
        <>
            <Helmet>

                <title>
                    Placement Assistance in Hyderabad | PRT Academy
                </title>

                <meta
                    name="description"
                    content="Get placement assistance in Hyderabad from PRT Academy with interview preparation, career guidance, resume support, mock interviews, and job search assistance."
                />

                <meta
                    name="keywords"
                    content="Placement Assistance in Hyderabad, IT Placement Assistance in Hyderabad, Placement Support in Hyderabad, Job Placement Assistance in Hyderabad, Placement Assistance for Freshers, IT Career Guidance in Hyderabad, Resume Building, Mock Interviews, Interview Preparation, Career Guidance, Job Search Assistance"
                />

            </Helmet>

            <section className="placements-page">

                <div className="page-badge">
                    Placement Support
                </div>

                <h1>
                    Get <span>Placement Ready</span>
                </h1>

                <p className="page-intro">
                    Build technical skills, prepare for interviews and develop
                    the confidence required to enter the software industry.
                </p>

                <div className="placement-grid">

                    <div className="placement-card">
                        <h2>Resume Preparation</h2>
                        <p>
                            Build a professional resume that highlights your
                            skills and projects.
                        </p>
                    </div>

                    <div className="placement-card">
                        <h2>Mock Interviews</h2>
                        <p>
                            Practice technical and HR interviews with mentor
                            guidance.
                        </p>
                    </div>

                    <div className="placement-card">
                        <h2>Coding Practice</h2>
                        <p>
                            Strengthen programming fundamentals and solve
                            interview-oriented problems.
                        </p>
                    </div>

                    <div className="placement-card">
                        <h2>Career Guidance</h2>
                        <p>
                            Get guidance throughout your job preparation
                            journey.
                        </p>
                    </div>

                </div>


                {/* =====================================
                    PLACEMENT FAQ
                ====================================== */}

                <section className="placement-faq-section">

                    <div className="placement-faq-badge">
                        Placement FAQ
                    </div>

                    <h2 className="placement-faq-title">
                        Frequently Asked <span>Questions</span>
                    </h2>

                    <p className="placement-faq-intro">
                        Find answers to common questions about PRT Academy
                        placement assistance, interview preparation and
                        career support.
                    </p>

                    <div className="placement-faq-list">

                        {placementFAQs.map((faq, index) => (

                            <div
                                className={`placement-faq-card ${
                                    placementOpenFAQ === index
                                        ? "placement-faq-active"
                                        : ""
                                }`}
                                key={index}
                            >

                                <button
                                    type="button"
                                    className="placement-faq-question"
                                    onClick={() =>
                                        togglePlacementFAQ(index)
                                    }
                                >

                                    <span>
                                        {faq.question}
                                    </span>

                                    <span className="placement-faq-icon">
                                        {placementOpenFAQ === index
                                            ? "−"
                                            : "+"}
                                    </span>

                                </button>

                                {placementOpenFAQ === index && (

                                    <div className="placement-faq-answer">

                                        <p>
                                            {faq.answer}
                                        </p>

                                    </div>

                                )}

                            </div>

                        ))}

                    </div>

                </section>

            </section>
        </>
    );
};

export default Placements;